export const DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN = 'DISPLAY_SQUAD_CHANGE_MODAL_FOR_CAPTAIN';
export const SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS = 'SET_PAYMENT_LOG_HISTORY_FOR_REG_MANAGE_TEAMS';
export const SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL = 'SET_ROSTER_WARNINGS_FOR_CAPT_ENTRY_DETAIL';
export const DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN = 'DISPLAY_EVENT_CHANGE_MODAL_FOR_CAPTAIN';



// WEBPACK FOOTER //
// ./src/features/registration/manage/constants.js